import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import axios from "axios";
import SetupGuide from "./SetupGuide";
import GoogleGA4Account from "./GoogleGA4Account";
import GoogleBingUAT from "./GoogleBingUAT";
import GooglePlan from "./ChangePlan";
import PlanViewPage from "./PlanViewPage";
import HowToUse from "./HowToUse";
import GoogleTag from "./GoogleTag";
import { checkPlanAndRedirect } from '../services/shopifyService';

const GoogleTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const tabs = [
    {
      name: "Google Ads",
      icon: "bi bi-microsoft",
      src: "?shop=googlepixx.myshopify.com",
      color: "#4285F4",
    },
    {
      name: "Google GA4 Account",
      icon: "bi bi-patch-question-fill",
      src: "?shop=googlepixx.myshopify.com",
      color: "#EA4335",
    },
    {
      name: "Google Tags",
      icon: "bi bi-patch-question-fill",
      src: "?shop=googlepixx.myshopify.com",
      color: "#FBBC05",
    },
    {
      name: "Bing UET Integration",
      icon: "bi bi-patch-question-fill",
      src: "?shop=googlepixx.myshopify.com",
      color: "#FBBC05",
    },
	    
	  {
      name: "How To Use",
      icon: "bi bi-patch-question-fill",
      src: "?shop=googlepixx.myshopify.com",
      color: "#34A853",
    }, 
    {
      name: "Change Plan",
      icon: "bi bi-patch-question-fill",
      src: "?shop=googlepixx.myshopify.com",
      color: "#34A853",
    },
	
	  
  ];
	
	  useEffect(() => {
        // Extract query parameters from the URL
        const urlParams = new URLSearchParams(location.search);
        const shop = urlParams.get('shop');
		const currentParams = window.location.search;
		  
		  
let data = JSON.stringify({
  "query": "SELECT customer_client.id,customer_client.descriptive_name,customer_client.manager, customer_client.level FROM customer_client WHERE customer_client.level = 1"
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://googleads.googleapis.com/v17/customers/6821399262/googleAds:search',
  headers: { 
    'developer-token': '1-HYpRG2Bn3mkzOrTXp2rg', 
    'Content-Type': 'application/json', 
    'Authorization': 'Bearer ya29.a0ARW5m75Jo2yUAVA5iJs36pVeTPaFA6EHelg4MtDV51HjqQe373lu1_PJbJd3vomHKnOzMx76tOijJw81vhOUsaMmd4BVRwSvTzEM17sLGZ21jMsMtma0759zVoikSYqoLWuQ2HtUdL18f09wAZfFbgNqhsIPQBRJIZE52ejzaCgYKAVESARMSFQHGX2MiKA5RyFkGoKW6jZd-H-8g5Q0175'
  },
  data : data
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
})
.catch((error) => {
  console.log(error);
});


		  

        if (shop) {
            checkPlanAndRedirect(shop, navigate,currentParams);
        } else {
            // Handle case where shop parameter is missing
            console.log('Shop parameter is missing in the URL');
        }
    }, [location.search]);
	

  return (
    <div className="main-tabs-screen">
      <div className="tabs-container">
        {tabs.map((val, ind) => (
          <Link
            to={val.src}
            key={ind}
            onClick={() => setTab(ind)}
            className={`tab-item ${tab === ind ? "active" : ""}`}
            style={{
              backgroundColor: tab === ind ? val.color : "#f5f5f5",
              color: tab === ind ? "#fff" : "#333",
              borderColor: tab === ind ? val.color : "transparent",
            }}
          >
            <i className={val.icon} style={{ marginRight: 8 }}></i>
            {val.name}
          </Link>
        ))}
      </div>

      <div className="tab-content">
        {(() => {
          switch (tab) {
            case 0:
              return <SetupGuide />;
            case 1:
              return <GoogleGA4Account />;
            case 2:
              return <GoogleTag />;
            case 3:
              return <GoogleBingUAT />;
			  case 4:
              return <HowToUse />;
            default:
              return <PlanViewPage />;
          }
        })()}
      </div>
    </div>
  );
};

export default GoogleTabs;
